import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              平台优势
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              为什么选择春色影视？五大核心优势告诉你答案
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="group bg-background-50 rounded-xl p-6 text-center border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-default"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className={`${feature.icon} text-2xl text-primary-500`}></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}